import { Error } from "@progress/kendo-react-labels"
import { useBlockCtx } from "../../../Context/BlockContext"
import { useGlobalCtx } from "../../../Context/GlobalContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHand } from '@fortawesome/pro-regular-svg-icons';

// interface BlockErrorProps {
//     isError: Boolean
// }

export const BlockError = () => {
    const globalCTX = useGlobalCtx()
    const blockCTX = useBlockCtx()

    return (

        <>
            {blockCTX.isError &&
                <div className="theme-validator-warning mt-3 pt-2 pb-2.5 px-4">
                    <Error className="theme-validator-warning-text align-top !text-base font-semibold" direction='start'><FontAwesomeIcon icon={faHand} className="!mt-1 theme-icon-spacer" />{globalCTX.LangResources.blockMsg.error}</Error>
                </div>

            }
        </>
    );
}